<x-shop-layout>
  <x-shop-header headerStyle="custom">
    <x-header-layout>
      <x-brand-logo xHeading xGoHomeLink queryParamsHandling="preserve"></x-brand-logo>
    </x-header-layout>
  </x-shop-header>

  <div xBody>
    <x-page-not-found [backToShopping]="false" [newProducts]="false">
      <button xAction mat-flat-button color="primary" xGoHomeLink queryParamsHandling="preserve">
        Back to shopping
      </button>
    </x-page-not-found>
  </div>
</x-shop-layout>
